import React from 'react';
import Link from '@material-ui/core/Link';
import {useTakisLinkStyle, useVariationsLinkStyle} from './TakisLink.styles'
import PropTypes from 'prop-types';

export default function TakisLink({href, type, target, title, logo, ariaDescription}) {

    const takisClasses = useTakisLinkStyle();
    const takisVariationsClasses = useVariationsLinkStyle();
    let logoElement;

    TakisLink.propTypes = {
        key: PropTypes.string,
        href: PropTypes.string.isRequired,
        type: PropTypes.string,
        target: PropTypes.string,
        title: PropTypes.string.isRequired,
        logo: PropTypes.string,
        ariaDescription: PropTypes.string
    };

    logo && (logoElement = <span className={takisVariationsClasses.linkSpan} ><img src={logo} alt=""></img></span>)

    return (
        <Link href={href} className={`${takisClasses.root} ${takisVariationsClasses[type]}`} target={target || "_blank"}
              rel={target === '_blank' ? 'noopener' : '' } title={title} aria-label={ariaDescription ? `${title} ${ariaDescription}` : title}>
            {logoElement}
            {title}
        </Link>
  );
}
